import { Routes } from '@angular/router';
import { routerSegments } from './consts/routes';
import { LayoutComponent } from './components/layout/layout.component';
import { authenticatedGuard } from './guards/authenticated.guard';
import { PublicAccessDeniedPageComponent, PublicEmailVerificationPageComponent, PublicResetPasswordPageComponent } from '@auth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: routerSegments.violations,
    pathMatch: 'full',
  },
  {
    path: routerSegments.violations,
    loadComponent: () => LayoutComponent,
    canActivate: [authenticatedGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/violations/violations.routes').then(
            (m) => m.violationsRoutes,
          ),
      },
    ],
  },
  {
    path: routerSegments.accountDetails,
    loadComponent: () => LayoutComponent,
    canActivate: [authenticatedGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/account-details/account-details.component').then(
            (m) => m.AccountDetailsComponent,
          ),
      },
    ],
  },
  {
    path: routerSegments.organizationSettings,
    loadComponent: () => LayoutComponent,
    canActivate: [authenticatedGuard],
    loadChildren: () =>
      import('./pages/organization-settings/organization-settings.routes').then(
        (m) => m.organizationSettingsRoutes,
      ),
  },
  {
    path: routerSegments.logout,
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: routerSegments.resetPassword,
    component: PublicResetPasswordPageComponent,
  },
  {
    path: routerSegments.emailVerification,
    component: PublicEmailVerificationPageComponent,
  },
  {
    path: routerSegments.accessDenied,
    component: PublicAccessDeniedPageComponent,
  },
  {
    path: routerSegments.notFound,
    loadChildren: () =>
      import('./pages/not-found/not-found.routes').then(
        (m) => m.notFoundRoutes,
      ),
  },
  {
    path: '**',
    redirectTo: routerSegments.violations,
  },
];
